import { ArrowBack } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from "@mui/material";
import defaultAxios, { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import Swal from "sweetalert2";
import axios from "../../services/axios";

interface IModalDeleteRuanganProps  {
    open: boolean;
    onClose: () => void;
    roomId: number;
    nama: string;
    onDeleted: () => void;
}

const ModalDeleteRuangan = ({
    open,
    onClose,
    roomId,
    nama,
    onDeleted
}: IModalDeleteRuanganProps ) => {
    const queryClient = useQueryClient();

    const nonActiveRoom = useMutation({
        mutationFn: async () => {
            const formData = new FormData();
            formData.append("isAktif", "0");
            formData.append("_method", "PATCH");
            const res = await axios.post(`/api/mruangans/${roomId}/status`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return res.data;
        },
    });

    const handleNonActive = async () => {
        nonActiveRoom.mutate(undefined, {
            onSuccess: () => {
                queryClient.invalidateQueries("ruangan");
                Swal.fire({
                    title: "Ruangan berhasil di Nonaktifkan!",
                    position: "top-end",
                    showConfirmButton: false,
                    icon: "success",
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    showCloseButton: true,
                    customClass: {
                        container: "my-swal",
                    },
                });
                onClose();
                onDeleted();
            },
            onError: (error) => {
                if (defaultAxios.isAxiosError(error)) {
                    const serverError = error as AxiosError<any>;
                    if (serverError && serverError.response) {
                        Swal.fire({
                            title: "Terjadi Kesalahan!",
                            text: `${serverError.response.data.message}`,
                            icon: "error",
                            confirmButtonColor: "#45A779",
                            customClass: {
                                container: "my-swal",
                            },
                        });
                        onClose();
                    } else {
                        Swal.fire({
                            title: "Terjadi Kesalahan!",
                            text: `Telah Terjadi Kesalahan`,
                            icon: "error",
                            confirmButtonColor: "#45A779",
                            customClass: {
                                container: "my-swal",
                            },
                        });
                        onClose();
                    }
                }
            },
        });
    };

    return (
        <Dialog
            maxWidth="xs"
            fullWidth={true}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: { borderRadius: 1 },
            }}
        >
            <DialogTitle>
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton
                        onClick={() => {
                            onClose();
                        }}
                    >
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h6" fontWeight="bold">
                        Non Aktifkan Ruangan
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Ruangan <b>{nama}</b> akan di Nonaktifkan. Yakin ingin Nonaktifkan?
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: 2 }}>
                <LoadingButton
                    loading={nonActiveRoom.isLoading}
                    loadingPosition="center"
                    variant="outlined"
                    onClick={() => handleNonActive()}
                    color="error"
                >
                    Nonaktifkan
                </LoadingButton>
                <Button
                    variant="contained"
                    onClick={() => {
                        onClose();
                    }}
                    color="error"
                >
                    Tidak
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalDeleteRuangan;